import * as React from 'react';

import { TELEMETRY_EVENT_TYPE } from 'telemetry/Constants';
import { getPathnameWithoutId } from 'util/URLUtils';
import { Button, MenuItem } from 'components/bootstrap';
import useSendTelemetry from 'logic/telemetry/useSendTelemetry';
import useLocation from 'routing/useLocation';
import { INTERNAL_DATA_LAKE_TYPE } from 'data-lake/Constants';
import type { DataLakeType } from 'data-lake/Types';
import type { DataLakeStorageType } from 'data-lake/preview/Types';
import { INTERNAL_DATA_LAKE_STORAGE_TYPE } from 'data-lake/preview/storage-types/internal/Constants';

type Props = {
  onClick: () => void;
  buttonType?: 'menu' | 'button';
  dataLakeType?: DataLakeType;
  dataLakeStorageType?: DataLakeStorageType;
};

const RetrievalArchiveButton = ({
  onClick,
  buttonType = 'menu',
  dataLakeType = INTERNAL_DATA_LAKE_TYPE,
  dataLakeStorageType = INTERNAL_DATA_LAKE_STORAGE_TYPE,
}: Props) => {
  const { pathname } = useLocation();
  const sendTelemetry = useSendTelemetry();

  const onRetrieval = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE[dataLakeType].DATA_RETRIEVAL_OPENED, {
      app_pathname: getPathnameWithoutId(pathname),
      event_details: {
        data_lake_storage_type: dataLakeStorageType,
      },
    });

    onClick();
  };

  const isMenuButton = buttonType === 'menu';
  const ItemComponent = isMenuButton ? MenuItem : Button;

  return (
    <ItemComponent onClick={onRetrieval} bsSize="xsmall">
      Retrieve logs
    </ItemComponent>
  );
};

export default RetrievalArchiveButton;
